import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsPromotionForbidden } from '../../../../selectors/publishTerms';

import { DeniedBySanctions } from '../PromotionSection/components/ServiceError/components/DeniedBySanctions';
import { WithoutServicesScreen } from './WithoutServicesScreen';

export const WithoutServicesScreenContainer = () => {
  const isPromotionForbidden = useSelector(selectIsPromotionForbidden);

  if (isPromotionForbidden) {
    return <DeniedBySanctions />;
  }

  return <WithoutServicesScreen />;
};
